import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'tasks';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const tasksActions = { ...slice.actions, ...extraActions };
export const tasksReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        tasks: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAllById: getAllById()
    };    

    function getAllById() {
        return createAsyncThunk(
            `${name}/getAllById`,
            async ({param}) => await fetchWrapper.get(`${baseUrl}/GetTasks/${param}`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAllById()
    };

    function getAllById() {
        var { pending, fulfilled, rejected } = extraActions.getAllById;
        return {
            [pending]: (state) => {
                state.tasks = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.tasks = action.payload;
            },
            [rejected]: (state, action) => {
                state.tasks = { error: action.error };
            }
        };
    }
}
